import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class IntakeTagAttribute extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._operator = init.operator
    this._data = init.data
    this._type = init.type
  }

  static shape = {
    id: PropTypes.string,
    operator: PropTypes.string,
    data: PropTypes.string,
    type: PropTypes.string
  }

  get id() {
    return this._id
  }

  get operator() {
    return this._operator
  }

  get data() {
    return this._data
  }

  get type() {
    return this._type
  }
}

export default IntakeTagAttribute
